<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '工控机'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5vh"
    :close-on-click-modal="false">
    <el-form :model="item" ref="itemform" label-width="100px" :rules="rules">
      <el-form-item label="工控机名称" prop="Name">
        <el-input v-model.trim="item.Name" placeholder="请输入工控机名称"></el-input>
      </el-form-item>
      <el-form-item label="工控机编号" prop="Sn">
        <el-input v-model.trim="item.Sn" placeholder="请输入机器号"></el-input>
      </el-form-item>
      <el-form-item label="MN号" prop="Mn">
        <el-input v-model.trim="item.Mn" placeholder="请输入MN号"></el-input>
      </el-form-item>
      <el-form-item label="工控机状态" prop="Status">
        <el-select v-model="item.Status" placeholder="请选择工控机状态" style="width: 100%">
          <el-option
            v-for="(status, index) in $sys.MS_STATUS"
            :key="index"
            :label="status"
            :value="+index">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出厂日期" prop="ProductionDay">
        <el-date-picker v-model="item.ProductionDay"
          style="width:100%"
          type="date"
          placeholder="选择出厂日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="购货单位" prop="PurchaseUnit">
        <el-input v-model.trim="item.PurchaseUnit" placeholder="请输入购货单位"></el-input>
      </el-form-item>
      <el-form-item label="领用人" prop="Recipient">
        <el-input v-model.trim="item.Recipient" placeholder="请输入领用人"></el-input>
      </el-form-item>
      <el-form-item label="软件版本" prop="SoftwareVersion">
        <el-input v-model.trim="item.SoftwareVersion" placeholder="请输入软件版本"></el-input>
      </el-form-item>
      <el-form-item label="硬件版本" prop="HardwareVersion">
        <el-input v-model.trim="item.HardwareVersion" placeholder="请输入硬件版本"></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="Comment">
        <el-input v-model.trim="item.Comment"
          type="textarea"
          :autosize="{ minRows: 2 }"
          placeholder="说明">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit"
        :disabled="submitting || !item.Name || !item.Sn">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    deviceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: '工控机名称不能为空', trigger: 'blur' },
          { max: 100, message: '工控机名称不能超过100个字', trigger: 'blur' },
        ],
        Sn: [
          { required: true, message: '工控机编号不能为空', trigger: 'blur' },
        ],
      },
      submitting: false,
    };
  },
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        // itemData.Status = +itemData.Status;
        // 保存的操作
        this.$axios.request({
          url: this.item.ID ? `ipcdevice/${itemData.ID}` : 'ipcdevice',
          method: itemData.ID ? 'put' : 'post',
          data: itemData,
        }).then(() => {
          this.$message.success(itemData.ID ? '编辑成功' : '新增成功');
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
